import {
  border,
  Box,
  Flex,
  HStack,
  Img,
  Link,
  Stack,
  VStack,
} from "@chakra-ui/react";
import profileFrame from "../../assets/images/profileFrame.png";
import linkedin from "../../assets/images/linkedin.png";
import twitter from "../../assets/images/twitter.png";
import facebook from "../../assets/images/facebook.png";
import MailIcon from "../../components/Icons/MailIcon";
import { useSelector } from "react-redux";
const sectionStyle = {
  marginBottom: "32px",
};

const headingStyle = {
  fontSize: "16px",
  fontWeight: 500,
  marginBottom: "8px",
};
const tagContainerStyle = {
  display: "flex",
  gap: "8px",
  flexWrap: "wrap",
};

const tagStyle = {
  padding: "4px 10px",
  backgroundColor: "#f3f4f6",
  borderRadius: "6px",
  fontSize: "14px",
};
const cardStyle1 = {
  padding: "5px",
  borderRadius: "8px",
  marginBottom: "10px",
};
const cardStyle = {
  backgroundColor: "#f9fafb",
  padding: "5px",
  borderRadius: "8px",
  marginBottom: "10px",
};

const profileHeaderStyle = {
  textAlign: "center",
};

const initiatives = [
  {
    initiative: "Improve cashflow",
    status: "Open",
    contributor: "Ajay Nagpal",
    additionalContributors: 3,
    function: "Operations",
  },
  {
    initiative: "Optimize production by 5%",
    status: "Open",
    contributor: "Ajay Nagpal",
    additionalContributors: 2,
    function: "Operations",
  },
];

const tableStyles = {
  container: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
    backgroundColor: "#F8F8F8",
    border: "none",
  },
  headerCell: {
    textAlign: "left",
    padding: "12px 16px",
    color: "#6B7280",
    fontWeight: 500,
    fontSize: "14px",
    backgroundColor: "#F9FAFB",
    borderBottom: "none",
  },
  cell: {
    padding: "16px",
    fontSize: "14px",
    borderBottom: "none",
  },
  statusBadge: {
    display: "inline-block",
    padding: "4px 12px",
    backgroundColor: "#F3F4F6",
    borderRadius: "16px",
    fontSize: "12px",
    color: "#374151",
  },
  contributorCell: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  avatar: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#E5E7EB",
  },
  contributorText: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
};

const buttonContainerStyle = {
  marginTop: "32px",
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
};

const buttonStyle = {
  padding: "4px 8px",
  backgroundColor: "#374151",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  margin: "5px 0px",
  justifyContent: "center",
  alignItems: "center",
};
const SMEProfile = ({ clientData }) => {
  return (
    <Box>
      <Stack
        alignItems={"start"}
        direction={{ base: "column", md: "row" }}
        gap="2"
        className="abc1"
      >
        <Box className="abc11">
          <HStack>
            <Box className="logoStyle">
              <Img src={clientData?.companyLogo} />
            </Box>
            <VStack>
              <div style={sectionStyle}>
                <h2 style={headingStyle}>Our Mission</h2>
                <p style={{ color: "#6b7280", fontSize: "16px" }}>
                  {clientData?.companyMission}
                </p>
              </div>
            </VStack>
          </HStack>
          <Stack direction={{ base: "column", md: "row" }} gap="1">
            <VStack alignItems={"start"}>
              {/* Disclosures */}
              <div style={sectionStyle}>
                <h2 style={headingStyle}>Our Disclosures</h2>
                <div style={tagContainerStyle}>
                  {clientData?.disclosures &&
                    clientData.disclosures.map((item) => (
                      <span key={item} style={tagStyle}>
                        {item}
                      </span>
                    ))}
                </div>
              </div>
              {/* Products */}
              <div style={sectionStyle}>
                <h2 style={headingStyle}>Our Products</h2>
                <div style={tagContainerStyle}>
                  {clientData?.products &&
                    clientData.products.map((product) => (
                      <span key={product._id} style={tagStyle}>
                        {product.product}
                      </span>
                    ))}
                </div>
              </div>
            </VStack>
            <VStack alignItems={"start"} display={"none"}>
              {/* Functional Heads */}
              <h2 style={headingStyle}>Functional Heads</h2>
              <Stack
                alignItems={"start"}
                direction={{ base: "column", md: "row" }}
                gap="2"
                className="abc1"
              >
                {/* Raj Kumar */}
                <Box
                  className="abc1"
                  width={{ base: "100%", md: "153px" }}
                  style={cardStyle}
                >
                  <div style={profileHeaderStyle}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={profileFrame}
                        alt="COO"
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          marginBottom: "8px",
                        }}
                      />
                    </div>
                    <div>
                      <h3 style={{ fontWeight: 600, fontSize: "14px" }}>
                        Raj Kumar
                      </h3>
                      <p
                        style={{
                          color: "#6b7280",
                          fontWeight: 400,
                          fontSize: "13px",
                        }}
                      >
                        Operational Head
                      </p>
                    </div>
                  </div>
                  <div>
                    <p
                      style={{
                        color: "#6b7280",
                        fontSize: "14px",
                        marginBottom: "8px",
                      }}
                    >
                      Contributed To +2
                    </p>
                    <div style={tagContainerStyle}>
                      <span style={tagStyle}>Improve Cashflow</span>
                      <span style={tagStyle}>Optimize Production By 5%</span>
                    </div>
                  </div>
                </Box>

                {/* Preity Verma */}
                <Box
                  className="abc1"
                  width={{ base: "100%", md: "153px" }}
                  style={cardStyle}
                >
                  <div style={profileHeaderStyle}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={profileFrame}
                        alt="COO"
                        style={{
                          width: "64px",
                          height: "64px",
                          borderRadius: "50%",
                          marginBottom: "8px",
                        }}
                      />
                    </div>
                    <div>
                      <h3 style={{ fontWeight: 600, fontSize: "14px" }}>
                        Preity Verma
                      </h3>
                      <p
                        style={{
                          color: "#6b7280",
                          fontWeight: 400,
                          fontSize: "13px",
                        }}
                      >
                        Production Manager
                      </p>
                    </div>
                  </div>
                  <div>
                    <p
                      style={{
                        color: "#6b7280",
                        fontSize: "14px",
                        marginBottom: "8px",
                      }}
                    >
                      Contributed To
                    </p>
                    <span style={tagStyle}>Optimize Production By 5%</span>
                  </div>
                </Box>
              </Stack>
            </VStack>
          </Stack>
        </Box>
        <Box className="abc12">
          <VStack alignItems={"start"}>
            <h2 style={headingStyle}>Leader's</h2>
            <Box
              className="SMEBackgroundBoxShadow"
              padding={"10px"}
              borderRadius={"8px"}
            >
              <Stack
                alignItems={"start"}
                direction={{ base: "column", md: "row" }}
                gap="2"
                className="abc1"
              >
                Raj Kumar
                {clientData?.leaders &&
                  clientData.leaders.slice(0, 2).map((leader, index) => (
                    <Box
                      key={index}
                      className="abc1"
                      width={{ base: "100%", md: "153px" }}
                      style={cardStyle}
                    >
                      <div style={profileHeaderStyle}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={`${leader?.profileImage || profileFrame}`}
                            alt="Leader"
                            style={{
                              width: "64px",
                              height: "64px",
                              borderRadius: "50%",
                              marginBottom: "8px",
                            }}
                          />
                        </div>
                        <div>
                          <h3 style={{ fontWeight: 600, fontSize: "14px" }}>
                            {leader?.full_name}
                          </h3>
                          <p
                            style={{
                              color: "#6b7280",
                              fontWeight: 400,
                              fontSize: "13px",
                            }}
                          >
                            {leader?.role}
                          </p>
                        </div>
                      </div>
                      <Link to={`mailto:${leader?.reachOutEmail}`}>
                        <Flex style={buttonStyle}>
                          <Box mr={"5px"}>
                            <MailIcon />
                          </Box>
                          <Box>Reach Out</Box>
                        </Flex>
                      </Link>
                      <Flex justifyContent={"space-evenly"} m={"10px 4px"}>
                        <Link to={leader?.linkedin}>
                          <Img src={linkedin} alt="linkedin" />
                        </Link>
                        <Link to={leader?.facebook}>
                          <Img src={facebook} alt="facebook" />
                        </Link>
                        <Link to={leader?.twitter}>
                          <Img src={twitter} alt="twitter" />
                        </Link>
                      </Flex>
                    </Box>
                  ))}
              </Stack>
            </Box>
          </VStack>
        </Box>

      </Stack>
      <VStack alignItems={"start"} display={"none"}>
        {/* Initiatives Table */}
        <div style={{ marginTop: "5px", width: "100%" }}>
          <h2 style={headingStyle}>Initiatives Undertaken</h2>
          <table
            style={tableStyles.container}
            className="SMEProfileInitiatives"
          >
            <thead>
              <tr>
                <th style={tableStyles.headerCell}>Initiative</th>
                <th style={tableStyles.headerCell}>Status</th>
                <th style={tableStyles.headerCell}>Contributers</th>
                <th style={tableStyles.headerCell}>Function</th>
              </tr>
            </thead>
            <tbody>
              {initiatives.map((item, index) => (
                <tr key={index}>
                  <td style={tableStyles.cell}>{item.initiative}</td>
                  <td style={tableStyles.cell}>
                    <span style={tableStyles.statusBadge}>{item.status}</span>
                  </td>
                  <td style={tableStyles.cell}>
                    <div style={tableStyles.contributorCell}>
                      <div style={tableStyles.avatar}></div>
                      <div style={tableStyles.contributorText}>
                        <span>{item.contributor}</span>
                        <span>+ {item.additionalContributors}</span>
                      </div>
                    </div>
                  </td>
                  <td style={tableStyles.cell}>{item.function}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </VStack>
    </Box>
  );
};

export default SMEProfile;
